import React, { useState } from "react";
import styles from "../login/Login.module.scss";
import AuthService from "../../../api/services/auth.service";
import Input from "../../../components/common/input/Input";
import { useAuth } from "../../../context/AuthContext";
import TitleUpdater from "../../../components/common/title/TitleUpdater";
import Button from "../../../components/common/button/Button";
import { useLocalizedNavigate } from "../../../hooks/useLocalizedNavigate";
import { useTranslation } from "react-i18next";

const ForgetPassword = () => {
  const { t } = useTranslation("translation");
  const { setEmail } = useAuth();
  const [emailValue, setEmailValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useLocalizedNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!emailValue) {
      setErrorMessage(t("errors.emailRequired") || "");
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("email", emailValue);
      const res = await AuthService.forgetPassword(formData);
      if (res.data) {
        navigate("/auth/confrim-forget-password");
        setEmail(emailValue);
      }
    } catch (error: any) {
      setLoading(false);
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        t("common_error");
      setErrorMessage(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.login}>
      <TitleUpdater title={t("forget_password")} />
      <div className="container">
        <div className={styles.content}>
          <form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.head}>
              <h1 className={styles.title}>{t("forget_password")}</h1>
              <p className={styles.description}>{t("forget_title")}</p>
              {errorMessage && (
                <p className={styles.errorMessage}>{errorMessage}</p>
              )}
            </div>
            <div className={styles.inputs}>
              <Input
                type="email"
                id="email"
                label={t("email") || ""}
                placeholder={t("placeholders.email") || ""}
                value={emailValue}
                onChange={(e) => {
                  setEmailValue(e.target.value);
                  setErrorMessage("");
                }}
                error={errorMessage}
              />
            </div>
            <div className={styles.login_btn}>
              <Button loading={loading} disabled={loading} type="submit">
                {t("submit")}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
